export default __webpack_public_path__ + "static/media/puzzleClue5.b164405e.png";